/** image 下载 */
import { downloadFileAPI } from '@/api/common'
import { adminFileDownByUrlAPI } from '@/api/admin/file'

/**
 *
 * @param {*} data url
 * @param {*} filename 名称
 */
export function getImageData(url) {
  return new Promise((resolve, reject) => {
    let request = null
    if (url.indexOf('adminFile/down/') !== -1) {
      request = adminFileDownByUrlAPI
    } else {
      request = downloadFileAPI
    }
    request(url).then(res => {
      const blob = new Blob([res.data], {
        type: ''
      })

      var reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onload = (evt) => {
        resolve({
          blob: blob,
          src: evt.target.result
        })
      }
    }).catch(() => {
      reject()
    })
  })
}

export const exportDefault = 'export default '

export const beautifierConf = {
  html: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'separate',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: false,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true
  },
  js: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'normal',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: true,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true
  }
}

// 首字母大小
export function titleCase(str) {
  return str.replace(/( |^)[a-z]/g, L => L.toUpperCase())
}

export function makeMap(str, expectsLowerCase) {
  const map = Object.create(null)
  const list = str.split(',')
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true
  }
  return expectsLowerCase
    ? val => map[val.toLowerCase()]
    : val => map[val]
}
// 数值处理工具 - 移除逗号并转换为数字
export function parseNumber(value) {
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  // 如果已经是数字，直接返回
  if (typeof value === 'number') {
    return value;
  }

  // 如果是字符串，先移除逗号再转换
  if (typeof value === 'string') {
    // 移除所有逗号
    const cleanValue = value.replace(/,/g, '');
    const num = parseFloat(cleanValue);
    return isNaN(num) ? 0 : num;
  }

  // 其他情况尝试转换
  const num = Number(value);
  return isNaN(num) ? 0 : num;
}
export function isNumberStr(str) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str)
}


/////检测浏览器版本
export function getBrowser(){
  let Sys = {};
  let ua = navigator.userAgent.toLowerCase();
  let s;
  let ver;
  (s = ua.match(/edge\/([\d.]+)/)) ? Sys.edge = s[1] :
    (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
      (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
        (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
          (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
            (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
              (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
  if (Sys.edge) return 1;
  if (Sys.ie) return 0;
  if (Sys.firefox) return 1;
  if (Sys.chrome){ ver = Sys.chrome;ver.toLowerCase();let arr = ver.split('.');if(parseInt(arr[0])>43){return 1;}else{return 0;}}
  if (Sys.opera) return 1;
  if (Sys.safari) return 1;
  return 1;
}



// WEBPACK FOOTER //
// ./src/utils/index.js